import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class LazyLoaderService {

  constructor() { }

  public loadScript(url) {
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);

    // console.log('loaded: ' + url);
  }
}
